import { makeStyles, tokens } from "@fluentui/react-components";
/** Styles for the CreatePlanDialog  */ export const useCreatePlanDialogStyles = makeStyles({
    root: {
        width: "100%",
        maxWidth: "1064px",
        padding: tokens.spacingHorizontalXXL,
        height: "646px",
        display: "flex",
        flexDirection: "column",
        overflow: "auto"
    },
    headerRow: {
        boxSizing: "border-box"
    },
    infoBannerRow: {
        marginBottom: tokens.spacingVerticalM
    },
    body: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        minHeight: 0
    },
    stepArea: {
        position: "relative",
        width: "100%",
        flexGrow: 1,
        minHeight: 0,
        height: "100%",
        overflow: "hidden"
    },
    detailsContainer: {
        display: "flex",
        flexDirection: "row",
        width: "100%",
        height: "100%",
        gap: tokens.spacingHorizontalL,
        alignItems: "stretch",
        minWidth: "1000px",
        boxSizing: "border-box"
    },
    stepPanel: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        overflowX: "auto",
        opacity: 0,
        transform: `translateX(${tokens.spacingHorizontalXL})`,
        transition: "opacity 120ms ease, transform 120ms ease",
        willChange: "opacity, transform",
        zIndex: 0,
        pointerEvents: "none"
    },
    stepPanelActive: {
        opacity: 1,
        transform: "translateX(0)",
        pointerEvents: "auto",
        zIndex: 2
    },
    stepPanelExit: {
        opacity: 0,
        transform: `translateX(calc(${tokens.spacingHorizontalXL} * -1))`,
        pointerEvents: "none",
        zIndex: 1
    }
});
